import React from "react";

import "./styles.scss";
import Breadcrumbs from "../../assets/component/breadcrumbs";
import uris from "../../config/uris";

const SupportMain = () => {

    const menuData = {
        title: "Support",
        parentMenu: {
            name: "Support",
            link: uris?.support
        },
    }

    return (
        <div className="support-main">
            <Breadcrumbs breadcrumbDetails={menuData} />
        </div>
    )
}

export default SupportMain